import { fetchAuthSession } from 'aws-amplify/auth';

export class AuthService {
  /**
   * Get the current auth token, handling auth errors consistently
   */
  public static async getAuthToken(): Promise<string> {
    try {
      const { tokens } = await fetchAuthSession();
      if (!tokens?.accessToken) {
        throw new Error('No access token available');
      }
      return tokens.accessToken.toString();
    } catch (error) {
      console.error('Auth error:', error);
      window.location.href = '/login';
      throw new Error('Authentication required. Please log in.');
    }
  }

  /**
   * Handle auth errors consistently across the application
   */
  public static handleAuthError(error: unknown): never {
    console.error('Authentication error:', error);
    window.location.href = '/login';
    throw new Error('Authentication required. Please log in.');
  }

  /**
   * Check if an error is an auth error
   */
  public static isAuthError(error: unknown): boolean {
    if (error instanceof Error) {
      return error.message.includes('Authentication required') ||
             error.message.includes('No access token available');
    }
    return false;
  }
} 